$(document).ready(function(){
  let bottom_title = $('#bottom-title').text();
  //alert(bottom_title);
  if (bottom_title){
  	$('#main-bottom-title').text(bottom_title);
  }
  function closeMatwiseCartDrawer() {
    $('.cart-widget').removeClass('show');
    $('.cart-overlay').removeClass('show');
    $('body').removeClass('nonscroll blocked-scroll');
    $('.cart-container').removeClass('active_link');
  }

  $(document).on('click', '.cart-widget-close, .cart-overlay, .cart-drawer-continue-shopping, .cart-widget .cart_content__continue-shopping', function(event) {
    event.preventDefault();
    closeMatwiseCartDrawer();
  });

  $(document).on('keydown', function(event) {
    if ((event.key === 'Escape' || event.keyCode === 27) && $('.cart-widget').hasClass('show')) {
      event.preventDefault();
      closeMatwiseCartDrawer();
    }
  });
  
});